<template>
    <!-- <b-modal        
        :title="item.eventName"
        v-model="showModal"
        @ok="handleOk"
        @cancel="handleCancel"
        @shown="modal_setFields"     
        @hidden="onHidden"
    > -->
    <b-modal        
        :title="eventName"
        v-model="showModal"        
        @shown="modal_setFields"     
        @hidden="onHidden"
        hide-footer
        :no-close-on-backdrop="true"
    >
        
        <div v-if="isload" style="height: 10px;">
            <b-progress :value="current_counter" :max="counter" animated></b-progress>
        </div>
        
        <CCard bodyWrapper class="card_background">
            <CRow>                
                <CCol sm="4">
                    <CSelect
                        :label="$t('Prediction type available')"
                        :placeholder="$t('select...')"
                        :options="predictionTypeOptions"
                        :value.sync="model.predictionType"
                        @update:value="handlePredictionTypeChange"
                    />
                </CCol>
                <CCol sm="8" style="display: flex;">
                    <CCol sm="3">
                        <CInput
                            :label="$t('Status')"
                            :plaintext="true"
                            :value="model.status"
                        />
                    </CCol>
                    <CCol sm="3">
                        <CInput
                            :label="$t('Score')"
                            :plaintext="true"
                            :value="model.score"
                        />
                    </CCol>
                    <CCol sm="6">
                        <CInput
                            :label="$t('Odd')"
                            :plaintext="true"
                            :value="model.odd"
                        />
                    </CCol>
                </CCol>
                
                <CCol sm="4">
                    <CSelect
                        :label="$t('Stake')"
                        :placeholder="$t('select...')"
                        :options="stakeOptions"
                        :value.sync="model.stake"
                    />
                </CCol>
                <CCol sm="4">
                    <CSelect
                        :label="$t('Visibility')"
                        :placeholder="$t('select...')"
                        :options="visibilityOptions"
                        :value.sync="model.visibility"
                    />
                </CCol>
                <CCol sm="4">
                    <CSelect
                        :label="$t('Add to Strategy')"
                        :placeholder="$t('select..')"
                        :options="strategyOptions"
                        :value.sync="strategy"
                    />
                </CCol>
            </CRow>

            <label>Cover(optional)</label>
            <CRow>
                <CCol sm="4">
                    <CSelect
                        :label="$t('Prediction type available')"
                        :placeholder="$t('select...')"
                        :options="predictionTypeOptions"
                        :value.sync="model.cover_predictionType"
                        @update:value="handleCoverPredictionTypeChange"
                    />
                </CCol>
                <CCol sm="4">
                    <CSelect
                        :label="$t('Stake')"
                        :placeholder="$t('select...')"
                        :options="stakeOptions"
                        :value.sync="model.cover_stake"
                    />
                </CCol>
                <CCol sm="4">
                    <CInput
                        :label="$t('Odd')"
                        :plaintext="true"
                        :value="model.cover_odd"
                    />
                </CCol>
            </CRow>
            <CRow>
                <CCol sm="12">
                    <CTextarea
                        label="Note(optional)"
                        :value.sync="model.note"
                        rows="7"
                    />
                </CCol>
            </CRow>
            <div class="d-flex justify-content-end action-btns">
                <CButton
                    v-if="postedTipId"
                    color="success"
                    class="m-2"
                    @click="handleClickNotification"
                >
                    {{ $t('Click here to see your tip') }}
                </CButton>
                
                <CButton
                    color="info"
                    class="m-2"
                    @click="handleReset"
                >
                    {{ $t('Cancel') }}
                </CButton>
                <CButton
                    color="info"
                    class="m-2"
                    :disabled="(canPost || cover_canPost) || loading"
                    @click="handlePostTip"
                >
                    {{ $t('Post tip') }}
                    <CSpinner v-if="loading" color="danger" size="sm" />
                </CButton>
                
            </div>
            <!-- <div v-if="postedTipId" style="margin-top: -30px">
            
                <span @click="handleClickNotification" style="color: blue; cursor: pointer;">Click here to see your tip</span>
            </div> -->
            <div style="clear: left; width: 100%; border: 1px solid lightgray; text-align: center; height: 30px;padding-top: 5px; margin-top: 20px; background: #e6eef5">
                <div style="width: 250px; margin: auto;">
                    <label style="float:left; font-weight: bold; margin-right: 10px;">{{ $t('Last Updated') }}: </label> 
                    <div style="float: left; background: #17a2b8; color: white; width: 80px; text-align: center; font-weight: bold;">{{last_updated_time}}</div>
                </div>
            </div>
        </CCard>
       
    </b-modal>
</template>

<script>
    import {mapActions, mapGetters } from 'vuex';
    import { capitalizeFL } from '@/helpers/string';

    import moment from 'moment';
    import {displaySuccess_stick, displayError_stick} from '../helpers/message';
    import {convertUTCToLocal} from '../helpers/time';

    export default {
        name: "PostTipModal",
        components: {
            
        },
        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
            
            item: {
                type: Object,
                required: true,
            }            
        },
        computed: {
            ...mapGetters(['loggedInUser']),
            isMe() {
                return this.loggedInUser && this.item.userId === parseInt(this.loggedInUser.user_id);
            },
            stakeOptions() {
                let result = [];
                for(let i = 0; i < 8; i++) {
                    result.push({
                        label: `${0.25*(i + 1).toFixed(2)}`,
                        value: 0.25 * (i + 1)
                    });
                }
                return result;
            },
            visibilityOptions() {
                let arr = [{
                        label: 'Public', 
                        value: 'public'
                    }, {
                        label: 'Private',
                        value: 'private'
                    }];
                return arr;
            },

            canPost() {                
                let result = true;
                let fResult = this.event;
                
                if(fResult) {
                    const {time: {status}} = fResult;
                    console.log("status", status)
                    if(status === 'NS' || status === 'LIVE' || status === 'HT') {
                        result = false;
                        for(const prop in this.model) {
                            if (prop == 'note' || prop == 'cover_predictionType' || prop == 'cover_stake' || prop == 'cover_odd' || prop == 'strategy')
                                continue
                            result = result || !this.model[prop];
                        }

                    }
                }
                
                return result;
            },
            cover_canPost() {
                let result = true;
                    
                if (this.model.cover_predictionType && this.model.cover_stake && this.model.cover_odd){
                    console.log("cover_canPost", result)
                    result = false;
                }
                else if (!this.model.cover_predictionType && !this.model.cover_stake && !this.model.cover_odd){
                    console.log("cover_canPost", result)
                    result = false;
                }
               console.log("cover_canPost", result)
                return result;
            }
            
            
        },
        data() {
            return {
                model: {
                    // date: '',
                    country: '',
                    league: '',
                    event: '',
                    predictionType: '',
                    stake: '',
                    visibility: '',
                    odd: '',
                    cover_predictionType: '',
                    cover_stake: '',
                    cover_odd: '',
                    note: '',
                },

                event: null,

                strategy: '',

                strategyOptions: [],
                predictionTypeOptions: [],
                loading: false,
                last_updated_time: "",
                tipQueue: [],

                isload: false,
                counter: 50,
                current_counter: 0,

                eventName: "",
                tip_posted: false,
                postedTipId: null,
                
            };
        },
        methods: {
             ...mapActions([
                'getFixtureById',
                'postTip',
                'getUserStrategies_mini',
                'postCashoutRef'
            ]),

             handleClickNotification() {
                
                var userId = localStorage.getItem('user_id');
                // if ( this.postedTipId ){
                //     this.$router.push({
                //         name: 'UserTipStat', 
                //         params: {
                //             id: userId,
                //             selected: this.postedTipId
                //         }
                //     });
                // }

                let routeData = this.$router.resolve({
                    name: 'UserTipStat',
                    params: {
                        id: userId,
                        selected: this.postedTipId
                    }
                });
                window.open(routeData.href, '_blank');
                
                       
               
            },

            getStrategyOptions() {
                this.getUserStrategies_mini().then(({data}) => {
                    this.strategyOptions = [
                        {label: 'None', value: ''}
                    ];
                    data.forEach((dItem) => {
                        this.strategyOptions.push({
                            label: dItem.name,
                            value: dItem._id
                        })
                    });
                });
            },

            checkEvent() {
                let _id = this.item.fixtureId;
                this.getFixtureById({_id: _id}).then(({data}) => {
                    if ( data.length > 0 ) {
                        this.event = data[0];
                    }
                    else {
                        this.event = null;
                    }

                    this.getEventInfo();

                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                    
                });
            },

            init() {
                this.isload = true;
                clearInterval(this.clock);
                this.clock = setInterval(this.frame, 100);

                console.log("eventId", this.item.fixtureId);
                let _id = this.item.fixtureId;
                this.getFixtureById({_id: _id}).then(({data}) => {
                    if ( data.length > 0 ) {
                        this.event = data[0];
                        this.eventName = data[0].localTeamName + " v " + data[0].visitorTeamName;
                    }
                    else {
                        this.event = null;
                        this.eventName = "";
                    }

                    this.getEventInfo();
                    this.model.country = this.item.country;
                    this.model.league = this.item.league;

                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                    this.isload = false;
                    this.percallfunction();
                });                
            },

            getEventInfo() {
                this.predictionTypeOptions = [];
                let labelList = [];
                /** save to compare score and odd */
                this.old_model = _.cloneDeep(this.model);
                let fResult = this.event;
                if(fResult) {
                    let odds = [];
                    let {localteam_score, visitorteam_score} = fResult.scores;
                    /** set status */
                    const time = fResult.time;
                    this.model.event = fResult._id;
                    this.model.status = time.status;
                    if(time.status === 'LIVE' || time.status === 'HT') {
                        let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                        let second = time.second ? time.second : '00';
                        let added_time = time.added_time ? `+${time.added_time}\'` : '';
                        this.model.status = `${time.status}  ${minute} ${second} ${added_time}`;
                    }
                    /** set score */
                    this.model.score = `${localteam_score} : ${visitorteam_score}`;
                    /** make prediction available types */
                    if(fResult.time.status === 'LIVE' || fResult.time.status == 'HT') {
                        odds = fResult.inplayOdds.data;
                    } else if(fResult.time.status === 'NS') {
                        odds = fResult.flatOdds.data;
                    }
                    const order = {
                        '1': 1,
                        '12': 2,
                        '136703813': 2,
                        '137918022': 2,
                        '28077': 2,
                        '1256989864': 2,
                        '37': 5,
                        '975903': 6, 
                        '976105': 7,
                        '31379': 8,
                        '31359': 8,
                        '976226': 9,
                        '63': 9, 
                        '28082': 10, 
                        '137918013': 10,
                        '136696391': 10,  
                    };
                    const next_market_ids = [1256989855,1265634174,1265634881,1265634165,1265634178,28096,1265634909,1265634945];
                    const drawnobet_market_ids = [28082,137918013,136696391];
                    odds.forEach((oItem) => {
                        let mkt_id = oItem.market_id;
                        if(oItem.bookmaker_id === 2) {
                            let suffix;
                            if(mkt_id === 1 || mkt_id === 12 || mkt_id === 976105  || mkt_id === 136703813 || mkt_id === 137918022 || mkt_id === 28077 || mkt_id === 1256989864) 
                                suffix = 'FT';
                            else if(mkt_id === 37 || mkt_id === 31379 || mkt_id === 975903 || mkt_id === 976226 || mkt_id === 31359)
                                suffix = 'HT';
                            // else if (next_market_ids.includes(oItem.market_id))
                            //     suffix = 'Next Goal';
                            // else if(oItem.market_id == 28182)
                            //     suffix = 'Last to score';
                            else if(oItem.market_id == 63)
                                suffix = 'Double chance';
                            else if (drawnobet_market_ids.includes(oItem.market_id))
                                suffix = 'Draw no bet';
                            // else if(oItem.market_id == 13343)
                            //     suffix = 'Team clean sheet';
                            // else if(oItem.market_id == 28088)
                            //     suffix = 'Home Ov/Un';
                            // else if(oItem.market_id == 28086)
                            //     suffix = 'Away Ov/Un';
                            // else if(oItem.market_id == 1256989856)
                            //     suffix = 'AH';
                            // else if(oItem.market_id == 1265635604)
                            //     suffix = 'Corners';
                            // else if(oItem.market_id == 136704329)
                            //     suffix = 'Cards';

                            if(suffix) {
                                (oItem.odds || oItem.values).forEach((item, index) => {
                                    let label;
                                    if (next_market_ids.includes(oItem.market_id) || oItem.market_id == 28182) {
                                        if (item.team)
                                            label = item.team;
                                        else
                                            label = 'No';
                                    }
                                    else if (oItem.market_id == 63) {
                                        if (index == 0)
                                            label = '1X';
                                        else if (index == 1)
                                            label = 'X2';
                                        else
                                            label = '12';
                                    }
                                    else if (drawnobet_market_ids.includes(oItem.market_id)) {
                                        if (index == 0)
                                            label = 'Home';
                                        else if (index == 1)
                                            label = 'Away';
                                    }
                                    else if(oItem.market_id == 13343) {
                                        var yesno = item.order;
                                        if (yesno === '0')
                                            yesno = 'Yes';
                                        else
                                            yesno = 'No';
                                        label = item.team + ' ' + yesno;
                                    }
                                    else if(oItem.market_id == 28086 || oItem.market_id == 28088) {
                                        label = item.info;
                                    }
                                    else if(oItem.market_id == 1256989856) {
                                        
                                        label = item.team + ' ' + item.handicap;
                                    }
                                    else if(oItem.market_id == 1265635604) {
                                        
                                        label = item.info;
                                    }
                                    else if(oItem.market_id == 136704329) {
                                        
                                        label = item.label;
                                    }
                                    else {
                                        if(item.label)
                                            label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                        else if(item.team)
                                            label = item.team;
                                        else if(item.info) {
                                            label = item.info;
                                        }

                                        if(label === 'Yes')
                                            label = 'BTS';
                                        else if(label === 'No')
                                            label = 'No BTS';
                                        if(label === '1')
                                            label = "Home";
                                        else if(label === '2')
                                            label = 'Away';
                                        else if(label === 'X')
                                            label = 'Draw';
                                    }
                                    
                                    if(!label.includes(",")) {              //except over 2.0,2.5 case
                                        var suspend_status = false;
                                        if (oItem.suspended !== null)
                                            suspend_status = oItem.suspended;
                                        else
                                            suspend_status = item.suspend;
                                        if (!suspend_status) {
                                            if (`${label} - ${suffix}`.trim() != 'Under - FT' && `${label} - ${suffix}`.trim() != 'Over - FT'){
                                                let label_suffix = `${label} - ${suffix}`;
                                                if (!labelList.includes(label_suffix) && !label.includes('.0')) {
                                                    this.predictionTypeOptions.push({
                                                        label: `${label} - ${suffix}`,
                                                        value: `${label} - ${suffix}`.trim(),
                                                        odd: parseFloat(item.value),
                                                        order: order[mkt_id]
                                                    });
                                                    labelList.push(label_suffix)
                                                }
                                                
                                            }
                                            
                                        }
                                        
                                    }
                                });
                            }
                        }
                    });
                    /** sort in order of FT, HT, BTS */
                    if(this.predictionTypeOptions.length > 0) {
                        this.predictionTypeOptions.sort((a, b) => {
                            if(a.order === 2 && b.order === 2) {
                                return a.value < b.value ? -1 : 0;
                            }
                            return a.order - b.order;
                        });
                        let fResult = this.predictionTypeOptions.find(fItem => fItem.value === this.model.predictionType);
                        if(!fResult)
                            this.handlePredictionTypeChange(this.predictionTypeOptions[0].value);
                        else
                            this.handlePredictionTypeChange(this.model.predictionType);

                        let cResult = this.predictionTypeOptions.find(fItem => fItem.value === this.model.cover_predictionType);
                        if(!cResult)
                            this.handleCoverPredictionTypeChange(this.predictionTypeOptions[0].value);
                        else
                            this.handleCoverPredictionTypeChange(this.model.cover_predictionType);
                    } else {
                        this.handlePredictionTypeChange('');
                        this.handleCoverPredictionTypeChange('');
                    }
                } else {
                    this.model.event = '';
                    this.model.predictionTypeOptions = [];
                    this.model.score = '';
                    this.model.odd = '';
                    this.model.status = '';
                    this.model.cover_odd = '';
                }
                /** check tip to post */
                if(this.old_model.odd === this.model.odd && this.old_model.score === this.model.score && this.old_model.cover_odd == this.model.cover_odd) {
                    this.tipQueue.forEach(tItem => {
                        try {
                            this.postTip(tItem).then((res) => {
                                this.loading = false;
                                console.log('res', res)
                                if ( res.status == "success") {
                                    displaySuccess_stick({message: "Success! Tip posted"});
                                    this.postedTipId = res.data.insertedId;
                                    console.log('this.postedTipId', this.postedTipId)
                                }
                                else {
                                    displayError_stick(res);
                                }
                            });
                        } catch(err) {
                            this.loading = false;
                            displayError_stick(err);
                        } finally {
                            this.tipQueue = [];
                            
                        }
                    });
                } else {
                    if(this.tipQueue.length > 0) 
                        displayError_stick({message: "Posting failed due to change of odds or score."});
                    this.tipQueue = [];
                    this.loading = false;
                }
                /** set updated time */
                this.last_updated_time = moment().format('hh:mm:ss');
            },
            modal_setFields() {
                this.model = {
                    // date: '',
                    country: '',
                    league: '',
                    // event: this.item.eventName,
                    predictionType: '',
                    stake: '',
                    visibility: '',
                    odd: '',
                    cover_predictionType: '',
                    cover_stake: '',
                    cover_odd: '',
                    note: '',
                }
            },
            onHidden() {
                this.$emit('hidePostModal'); 
                // this.$parent.$parent.hidePostModal(this.item.eventId);
            },
            handlePredictionTypeChange(val) {
                let fResult = this.predictionTypeOptions.find(pItem => pItem.value === this.model.predictionType);
                if(fResult) {
                    this.model.odd = fResult.odd;
                } else {
                    this.model.odd = '';
                }
            },
            handleCoverPredictionTypeChange(val) {
                let fResult = this.predictionTypeOptions.find(pItem => pItem.value === this.model.cover_predictionType);
                if(fResult) {
                    this.model.cover_odd = fResult.odd;
                } else {
                    this.model.cover_odd = '';
                }
            },
            handleReset() {
                this.onHidden();
            },
            handlePostTip() {
                var userId = localStorage.getItem('user_id');
                this.tipQueue.push({
                    ...this.model,                    
                    userId: parseInt(userId),
                    strategy: this.strategy
                });
                this.loading = true;
            },

            capitalizeVisibility(str) {
                return capitalizeFL(str);
            },
            
           
            frame() {
                if (this.current_counter >= 45) {
                    this.current_counter = 45
                    clearInterval(this.clock);
                } else {
                    this.current_counter++;                    
                }
            },
            percallfunction(){
                this.isload = false;
                this.current_counter = 0;
                clearInterval(this.clock); 
            },
            
        },
        mounted() {
            
        },
        created() {
            this.getStrategyOptions();
            this.init();

            this.timer = setInterval(() => this.checkEvent(), 13000); 
        },
        updated() {
            // this.calcCashOut();
        },
        watch: {
            // showModal (newVal) {
            //     if(newVal) {
            //         console.log("showing modal watch")
            //         console.log("this.$refs", this.$refs)
            //         this.$refs.myModalRef.show();
            //         // this.$bvModal.show("myModalRef");
            //     } else {
            //         console.log("hide modal")
            //         this.$refs.myModalRef.hide();
            //     }
            // }
        },
        beforeDestroy() {
            if(this.timer)
                clearInterval(this.timer);
        }
    }
</script>

<style lang="scss" scoped>
    .cash_out_cell {
        margin-top: auto;
        margin-bottom: auto;
    }
    .settled-lost {
        font-weight: 700;
        color: #FF0000;
    }

    .settled-won {
        font-weight: 700;
        color: #00FF00;
    }

    .settled-void {
        font-weight: 700;
        color: #0000FF;
    }
    .auto_cashout {
        font-weight: normal;
        float: right;
        padding-right: 53px;
        color: blue;
    }
    .auto_cashout:hover {
        
        cursor: pointer;
    }
    .comments_btn {
        color: blue;
    }
    .comments_btn:hover {
        
        cursor: pointer;
    }

    .posted_date {
        text-align: end;
    }

    .second_line_left_hidden {
        display: none !important;
    }

    .horizon_line {
        color: #d3d3d3;
        height: 1px;
    }

    .feed_page_second_line {
        display: flex;
        flex-wrap: wrap;
        /* justify-content: start; */

    }

    .avatar_container {
        display: block !important;
        text-align: center !important;
        margin-left: 50px;
        border-right: 1px solid #d3d3d3;
        padding: 20px;
    }

    .feed_avatar {
        padding: 0;

    }

    .post-comment > input{
        background-color: #fffaf0 !important;
    }

    .post-card {
        .header {
            .header-item {
                display: flex;
                justify-content: space-between;
                position: relative;

                div {
                    display: flex;
                }
            }
        }

        .unread-mark {
            top: 0px;
            left: 0px;
        }

        .note-box {
            position: relative;
            padding: 5px;
            background-color: whitesmoke;
            border-radius: 5px;
            margin-top: 10px;

            .note {
                padding: 5px;
                margin: 0 0 10px;
                min-height: 20px;
                padding-bottom: 0;
            }
        }

        .comments {
            padding: 0 0 0 40px;

            .comment {
                position: relative;

                .comment-header {
                    display: flex;
                    align-items: center;

                    .vue-avatar--wrapper {
                        margin-right: 15px;
                    }
                }

                p {
                    padding-left: 45px;
                }
            }
        }

        .post-comment {
            text-align: right;
            margin-bottom: 10px;

            .btn {}
        }
    }

    .comment_area {
        padding: 8px 35px !important;
        border: 1px solid #deddda;
        background-color: #fffaf0;
        border-radius: 7px;
        margin-left: 30px;
        max-width: 100%;
        display: inline-block;
    }

    .posted_date_mb{
       text-align: end;
    }
    .second_line_right{
        width: 75%;
        padding: 20px;
        margin-right: 0 !important;
        background-color: white;
        border-radius: 5px;
        border: none;
    }
    .sub_post_comment > .form-control{
        background-color: blue !important;
    }

    .avatar_link, .avatar_link_under{
        font-size: 18px;
        font-weight: bold;
    }
    .bold_head{
        font-size: 20px;
    }
    .tips_font18{
        font-size: 18px;
    }
    .right_bottom{
        font-size: 16px;
        margin-top: 10px;
        padding: 5px;
        background-color: whitesmoke;
        border-radius: 5px;
    }
    .hr_underpost{
        background-color: #a4c1c4;
    }
    .cash_out_details{
        font-weight: bold;
    }
    .parent_cash_out_details{
        padding: 5px;
        background-color: whitesmoke;
        margin-top: 5px;
        border-radius: 5px;
    }
    .comments_button_box{
        background-color: white;
        padding: 10px;
        border-radius: 5px;
        width: 100%;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .note_letters{
        margin-bottom: 0;
        font-weight: bold;
    }
    @media (min-width: 576px) {
        .desktop_hide{
            display: none;
        }
    }
    @media (max-width: 576px) {
        .comments_button{
            min-width: 50px;
        }
        .hr_underpost{
            display: none;
        }
        .modile_hide {
            display: none;
        }
        .note_letters{
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 0 !important;
            padding-bottom: 0;
        }
        .bold_head{
            font-size: 14px;
        }
        .tips_font18{
            font-size: 12px;
        }
        .cash_out_details{
            font-size: 14px;
        }
        .right_bottom{
            font-size: 14px;
        }
        .right_bottom > div{
            margin-top: 5px;
        }
        .feed_page_second_line{
            display: block;
        }
        .second_line_right{
            width: 100%;
            padding: 10px;
        }
        .horizon_line{
            margin-bottom: 0;
        }
       
        .avatar_right_letters{
            display: block !important;
            text-align: center;
        }
        .avatar_right_letters > a{
            margin-left: 10px;
            font-weight: 700 !important;
            font-size: 15px !important;
        }
        .posted_date_mb{
            font-size: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
        }
        .post-card{
            font-size: 12px !important;
            letter-spacing: -0.7;
        }
        .cashout_button{
            font-size: 11.5px !important;
            height: 23px;
            
        }
        
        .second_line_left_hidden{
            display: flex !important;
            align-items: center;
        }
        .second_line_left {
            display: none !important;
        }
        .delete_tip {
            font-size: 25px;
            
        }
        .delete_comment {
            font-size: 25px;
        }
    }

    .delete_tip {
        
        font-size: 30px;
        float: right;
        margin-left: 20px;
        margin-top: -15px;
        color: red;
        font-weight: 900;
    }

    .delete_comment {
        
        margin-top: -5px;
        font-size: 30px;
        color: red;
        font-weight: 900;
    }

    .cashout_button{
        white-space: nowrap;
        text-align: center;
    }

    .online-mark {
        width: 10px;
        height: 10px;
        display: inline-block;
        background-color: green;
        border-radius: 50%;
        margin-right: 3px;
    }
    .offline-mark {
        width: 10px;
        height: 10px;
        display: inline-block;
        background-color: #bec0c2;
        border-radius: 50%;
        margin-right: 3px;
    }
</style>